module.exports = __webpack_public_path__ + "media/images/product-default-f96e886a.png";